
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/detail/[id]/[slug]",
      function () {
        return require("private-next-pages/detail/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/detail/[id]/[slug]"])
      });
    }
  